// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Atom_Box from "../../design-system/atom/Atom_Box.bs.js";
import * as Atom_Text from "../../design-system/atom/Atom_Text.bs.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";

function Presse_Input_Label(Props) {
  var htmlFor = Props.htmlFor;
  var label = Props.label;
  var variant = Props.variant;
  var tag = Props.tag;
  var tmp = {
    children: label
  };
  if (variant !== undefined) {
    tmp.variant = Caml_option.valFromOption(variant);
  }
  if (tag !== undefined) {
    tmp.tag = Caml_option.valFromOption(tag);
  }
  return React.createElement(Atom_Box.make, {
              children: React.createElement(Atom_Text.Presse.make, tmp),
              kind: {
                TAG: /* Label */8,
                _0: htmlFor
              }
            });
}

var make = Presse_Input_Label;

export {
  make ,
}
/* react Not a pure module */
